import React, { useEffect, useState } from 'react';
import { PlusOutlined, SearchOutlined, CheckOutlined, CloseOutlined } from '@ant-design/icons';
import { Button, Col, DatePicker, Input, Popconfirm, Row, Select, Space, Table, Tag, Tooltip, Modal } from 'antd';
import { Link, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { ContentHeader } from '../../components';
import { menuHelper } from '../../helpers/account';
import { Links } from '../../helpers/Links';
import { BienBanBanGiao, TrangThaiBienBanBanGiao } from '../../models/taisan/BienBanBanGiao';
import { timKiemDSBienBanBanGiao, xacNhanBanGiao, tuChoiBanGiao, huyBienBan, thuHoiBienBan } from '../../services/bienBanBanGiao';
import DonViSelectTree from '../utils/DonViSelectTree';
import moment from 'moment';
import { responseStatus } from '../../constants';

const { RangePicker } = DatePicker;
const { TextArea } = Input;

const DanhSachBienBanBanGiao = () => {
    const navigate = useNavigate();
    const menu: any = menuHelper.checkMultiPermission([Links.BienBanBanGiao.ChiTiet, Links.BienBanBanGiao.Xem, Links.BienBanBanGiao.XacNhan]);
    const user = useSelector((state: any) => state.auth.currentUser);
    const [loading, setLoading] = useState<boolean>(false);
    const [dsBienBan, setDsBienBan] = useState<BienBanBanGiao[]>([]);
    const [total, setTotal] = useState<number>(0);
    const [currentPage, setCurrentPage] = useState<number>(1);
    const [pageSize, setPageSize] = useState<number>(10);

    // Filter
    const [tuKhoa, setTuKhoa] = useState<string>("");
    const [trangThai, setTrangThai] = useState<number | undefined>();
    const [idDonViGiao, setIdDonViGiao] = useState<number | undefined>();
    const [idDonViNhan, setIdDonViNhan] = useState<number | undefined>();
    const [tuNgay, setTuNgay] = useState<Date | undefined>();
    const [denNgay, setDenNgay] = useState<Date | undefined>();

    // Modal
    const [showModalTuChoi, setShowModalTuChoi] = useState<boolean>(false);
    const [idBienBanTuChoi, setIdBienBanTuChoi] = useState<number>(0);
    const [lyDoTuChoi, setLyDoTuChoi] = useState<string>("");

    const trangThaiOptions = [
        { value: TrangThaiBienBanBanGiao.DuThao, label: 'Dự thảo' },
        { value: TrangThaiBienBanBanGiao.ChoXacNhan, label: 'Chờ xác nhận' },
        { value: TrangThaiBienBanBanGiao.HoanThanh, label: 'Hoàn thành' },
        { value: TrangThaiBienBanBanGiao.ThuHoi, label: 'Thu hồi' },
        { value: TrangThaiBienBanBanGiao.Huy, label: 'Hủy' },
    ];

    const getTrangThaiTag = (trangThai: number) => {
        switch (trangThai) {
            case TrangThaiBienBanBanGiao.DuThao:
                return <Tag color="default">Dự thảo</Tag>;
            case TrangThaiBienBanBanGiao.ChoXacNhan:
                return <Tag color="blue">Chờ xác nhận</Tag>;
            case TrangThaiBienBanBanGiao.HoanThanh:
                return <Tag color="green">Hoàn thành</Tag>;
            case TrangThaiBienBanBanGiao.ThuHoi:
                return <Tag color="orange">Thu hồi</Tag>;
            case TrangThaiBienBanBanGiao.Huy:
                return <Tag color="default">Hủy</Tag>;
            default:
                return <Tag>Không xác định</Tag>;
        }
    };

    const columns = [
        {
            title: 'STT',
            dataIndex: 'stt',
            key: 'stt',
            width: 60,
            render: (_: any, __: any, index: number) => (currentPage - 1) * pageSize + index + 1,
        },
        {
            title: 'Ngày lập',
            dataIndex: 'ngayLap',
            key: 'ngayLap',
            width: 120,
            render: (date: Date) => moment(date).format('DD/MM/YYYY'),
        },
        {
            title: 'Phòng ban giao',
            dataIndex: 'tenDonViGiao',
            key: 'tenDonViGiao',
            width: 180,
        },
        // {
        //     title: 'Người giao',
        //     dataIndex: 'tenNVGiao',
        //     key: 'tenNVGiao',
        //     width: 150,
        //     render: (text: string) => text || '-',
        // },
        {
            title: 'Phòng ban nhận',
            dataIndex: 'tenDonViNhan',
            key: 'tenDonViNhan',
            width: 180,
        },
        // {
        //     title: 'Người nhận',
        //     dataIndex: 'tenNVNhan',
        //     key: 'tenNVNhan',
        //     width: 150,
        //     render: (text: string) => text || '-',
        // },
        {
            title: 'SL tài sản',
            dataIndex: 'soLuongTaiSan',
            key: 'soLuongTaiSan',
            width: 100,
            align: 'center' as 'center',
        },
        {
            title: 'Trạng thái',
            dataIndex: 'trangThai',
            key: 'trangThai',
            width: 130,
            render: (trangThai: number) => getTrangThaiTag(trangThai),
        },
        {
            title: 'Thao tác',
            key: 'action',
            width: 150,
            align: "center" as const,
            fixed: 'right' as 'right',
            render: (_: any, record: BienBanBanGiao) => (
                <Space>
                    {menu[Links.BienBanBanGiao.Xem] && (
                        <Tooltip title="Xem chi tiết">
                            <Link to={`${Links.BienBanBanGiao.Xem}?id=${record.id}`} className="hrm-btn hrm-btn-sm btn-success">
                                Xem
                            </Link>
                        </Tooltip>
                    )}
                    {menu[Links.BienBanBanGiao.ChiTiet] && record.idNVKhoiTao === user?.id && (record.trangThai === TrangThaiBienBanBanGiao.DuThao || record.trangThai === TrangThaiBienBanBanGiao.ThuHoi) && (
                        <>
                            <Tooltip title="Sửa">
                                <Button
                                    type="primary"
                                    size="small"
                                    className="hrm-btn hrm-btn-warning"
                                    onClick={() => navigate(`${Links.BienBanBanGiao.ChiTiet}?id=${record.id}`)}
                                >
                                Sửa
                                </Button>
                            </Tooltip>
                            <Popconfirm
                                title="Hủy biên bản"
                                description="Bạn có chắc chắn muốn hủy biên bản bàn giao này?"
                                onConfirm={() => handleHuyBienBan(record!.id ?? 0)}
                                okText="Đồng ý"
                                cancelText="Hủy"
                            >
                                <Button type="primary" size="small" className="hrm-btn hrm-btn-delete">Hủy</Button>
                            </Popconfirm>
                        </>
                    )}
                    {menu[Links.BienBanBanGiao.XacNhan] && record.coTheXacNhan && record.trangThai === TrangThaiBienBanBanGiao.ChoXacNhan && (
                        <>
                            <Popconfirm
                                title="Xác nhận bàn giao"
                                description="Bạn có chắc chắn muốn xác nhận biên bản bàn giao này?"
                                onConfirm={() => handleXacNhan(record!.id ?? 0)}
                                okText="Đồng ý"
                                cancelText="Hủy"
                            >
                                <Tooltip title="Xác nhận">
                                    <Button type="link" icon={<CheckOutlined style={{ color: 'green' }} />} />
                                </Tooltip>
                            </Popconfirm>
                            <Tooltip title="Từ chối">
                                <Button
                                    type="link"
                                    icon={<CloseOutlined style={{ color: 'red' }} />}
                                    onClick={() => {
                                        setIdBienBanTuChoi(record!.id ?? 0);
                                        setShowModalTuChoi(true);
                                    }}
                                />
                            </Tooltip>
                        </>
                    )}
                    {menu[Links.BienBanBanGiao.ChiTiet] && record.idNVKhoiTao === user?.id && record.trangThai === TrangThaiBienBanBanGiao.ChoXacNhan && (
                        <Popconfirm
                            title="Thu hồi biên bản"
                            description="Bạn có chắc chắn muốn thu hồi biên bản bàn giao này?"
                            onConfirm={() => handleThuHoiBienBan(record!.id ?? 0)}
                            okText="Đồng ý"
                            cancelText="Hủy"
                        >
                            <Button type="primary" size="small" className="hrm-btn hrm-btn-warning">Thu hồi</Button>
                        </Popconfirm>
                    )}
                </Space>
            ),
        },
    ];

    const loadDanhSach = async () => {
        try {
            setLoading(true);
            const result = await timKiemDSBienBanBanGiao(
                {
                    tuKhoa,
                    trangThai,
                    idDonViGiao,
                    idDonViNhan,
                    tuNgay,
                    denNgay,
                },
                (currentPage - 1) * pageSize,
                pageSize
            );
            setDsBienBan(result.data);
            setTotal(result.recordsTotal);
        } catch (error: any) {
            toast.error('Lỗi khi tải danh sách biên bản: ' + error.message);
        } finally {
            setLoading(false);
        }
    };

    const handleTimKiem = () => {
        setCurrentPage(1);
        loadDanhSach();
    };

    const handleThemMoi = () => {
        navigate(Links.BienBanBanGiao.ChiTiet);
    };

    const handleXacNhan = async (id: number) => {
        try {
            setLoading(true);
            var response = await xacNhanBanGiao(id);
            if (response.trangThai == responseStatus.thanhCong) {
                toast.success('Xác nhận bàn giao thành công');
                loadDanhSach();
            } else {
                toast.error(`Xác nhận bàn giao không thành công: ${response.thongBao}`);
            }
        } catch (error: any) {
            toast.error('Lỗi khi xác nhận: ' + error.message);
        } finally {
            setLoading(false);
        }
    };

    const handleTuChoi = async () => {
        if (!lyDoTuChoi.trim()) {
            toast.warning('Vui lòng nhập lý do từ chối');
            return;
        }
        try {
            setLoading(true);
            var response = await tuChoiBanGiao(idBienBanTuChoi, lyDoTuChoi);
            if (response.trangThai == responseStatus.thanhCong) {
                toast.success('Từ chối bàn giao thành công');
                loadDanhSach();
            } else {
                toast.error(`Từ chối bàn giao không thành công: ${response.thongBao}`);
            }
            setShowModalTuChoi(false);
            setLyDoTuChoi("");
        } catch (error: any) {
            toast.error('Lỗi khi từ chối: ' + error.message);
        } finally {
            setLoading(false);
        }
    };

    const handleHuyBienBan = async (id: number) => {
        try {
            setLoading(true);
            await huyBienBan(id);
            toast.success('Hủy biên bản thành công');
            loadDanhSach();
        } catch (error: any) {
            toast.error('Lỗi khi hủy biên bản: ' + error.message);
        } finally {
            setLoading(false);
        }
    };

    const handleThuHoiBienBan = async (id: number) => {
        try {
            setLoading(true);
            await thuHoiBienBan(id);
            toast.success('Thu hồi biên bản thành công');
            loadDanhSach();
        } catch (error: any) {
            toast.error('Lỗi khi thu hồi biên bản: ' + error.message);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        loadDanhSach();
    }, [currentPage, pageSize]);

    return (
        <div>
            <ContentHeader title="Danh sách biên bản bàn giao tài sản" />
            <section className="content">
                <div className="container-fluid">
                    <div className="card">
                        <div className="card-body">
                            {/* Bộ lọc */}
                            <Row gutter={[16, 16]} style={{ marginBottom: 16 }}>
                                <Col xs={24} sm={12} md={6}>
                                    <Input
                                        placeholder="Tìm kiếm..."
                                        value={tuKhoa}
                                        onChange={(e) => setTuKhoa(e.target.value)}
                                        onPressEnter={handleTimKiem}
                                        prefix={<SearchOutlined />}
                                    />
                                </Col>
                                <Col xs={24} sm={12} md={3}>
                                    <Select
                                        placeholder="Trạng thái"
                                        value={trangThai}
                                        onChange={setTrangThai}
                                        allowClear
                                        style={{ width: '100%' }}
                                        options={trangThaiOptions}
                                    />
                                </Col>
                                <Col xs={24} sm={12} md={6}>
                                    <DonViSelectTree
                                        allowClear
                                        autoSelectFirst={false}
                                        value={idDonViGiao}
                                        onChange={(e) => setIdDonViGiao(e.target.value)}
                                    />
                                </Col>
                                <Col xs={24} sm={24} md={5}>
                                    <RangePicker
                                        style={{ width: '100%' }}
                                        format="DD/MM/YYYY"
                                        placeholder={['Từ ngày', 'Đến ngày']}
                                        onChange={(dates) => {
                                            if (dates) {
                                                setTuNgay(dates[0]?.toDate());
                                                setDenNgay(dates[1]?.toDate());
                                            } else {
                                                setTuNgay(undefined);
                                                setDenNgay(undefined);
                                            }
                                        }}
                                    />
                                </Col>
                                <Col xs={24} sm={12} md={4}>
                                    <Space>
                                        <Button type="primary" icon={<SearchOutlined />} onClick={handleTimKiem}>
                                            Tìm kiếm
                                        </Button>
                                        {menu[Links.BienBanBanGiao.ChiTiet] && (
                                            <Button type="primary" className="hrm-btn hrm-btn-warning" icon={<PlusOutlined />} onClick={handleThemMoi}>
                                                Thêm mới
                                            </Button>
                                        )}
                                    </Space>
                                </Col>
                            </Row>

                            {/* Bảng dữ liệu */}
                            <Table
                                columns={columns}
                                dataSource={dsBienBan}
                                loading={loading}
                                rowKey="id"
                                scroll={{ x: 1500 }}
                                pagination={{
                                    current: currentPage,
                                    pageSize: pageSize,
                                    total: total,
                                    showSizeChanger: true,
                                    showTotal: (total) => `Tổng số: ${total} bản ghi`,
                                    onChange: (page, pageSize) => {
                                        setCurrentPage(page);
                                        setPageSize(pageSize);
                                    },
                                }}
                            />
                        </div>
                    </div>
                </div>
            </section>

            {/* Modal từ chối */}
            <Modal
                title="Từ chối bàn giao"
                open={showModalTuChoi}
                onOk={handleTuChoi}
                onCancel={() => {
                    setShowModalTuChoi(false);
                    setLyDoTuChoi("");
                }}
                okText="Xác nhận"
                cancelText="Hủy"
            >
                <div style={{ marginTop: 16 }}>
                    <label>Lý do từ chối: <span style={{ color: 'red' }}>*</span></label>
                    <TextArea
                        rows={4}
                        value={lyDoTuChoi}
                        onChange={(e) => setLyDoTuChoi(e.target.value)}
                        placeholder="Nhập lý do từ chối..."
                        maxLength={500}
                    />
                </div>
            </Modal>
        </div>
    );
};

export default DanhSachBienBanBanGiao;
